





















































import mixins from 'vue-typed-mixins'
import DraftElement from '@/builder/sections/mixins/DraftElement'
import VCardWrapper from '@/builder/sections/section/calendars/components/VCardWrapper.vue'

export default mixins(DraftElement).extend({
  components: { VCardWrapper },
  props: {
    textColor: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: null
    },
    classForViewRound: {
      type: String,
      default: ''
    },
    changeMode: {
      type: Boolean,
      default: false
    },
    locationTitle: {
      type: String,
      default: null
    },
    locationSubtitle: {
      type: String,
      default: null
    },
    providerType: {
      type: Number,
      default: null
    }
  },
  computed: {
    panelTitle (): string {
      return this.locationTitle || this.$trans('service_location_online')
    },
    panelSubtitle (): string | null {
      if (this.locationSubtitle === null) {
        return this.$trans('service_location_3')
      }

      return this.locationSubtitle || null
    },
    providerLogo (): string | null {
      // Client-side LocationType ids: 3 Google Meet, 5 Zoom, 6 Microsoft Teams.
      switch (this.providerType) {
        case 3:
          return require('@/assets/google-meet-small-logo.png')
        case 5:
          return require('@/assets/zoom-logo-square.png')
        case 6:
          return require('@/assets/teams-logo-small.png')
        default:
          return null
      }
    }
  }
})
